import React from 'react';
import { Section } from './ui/Section';
import { useLang } from '../contexts/LanguageContext';
export function About() {
  const {
    t
  } = useLang();
  return <Section id="about" background="white" className="border-t border-neutral-100" data-id="element-2">
      <div className="grid md:grid-cols-2 gap-12 lg:gap-24 items-start" data-id="element-3">
        {/* Left: image */}
        <div className="relative mt-8 md:mt-0 order-2 md:order-1" data-id="element-4">
          <div className="w-full h-[500px] bg-neutral-100 relative overflow-hidden border border-neutral-200" data-id="element-5">
            <img src="https://cdn.magicpatterns.com/uploads/tH86Fmei59qFjbGBG8fziW/IMG_4241.jpg" alt="Бухгалтер за роботою" className="w-full h-full object-cover object-center" data-id="element-6" />
            <div className="absolute inset-0 bg-gradient-to-t from-white/10 to-transparent" data-id="element-7"></div>
          </div>
          <div className="mt-4 border-b border-black pb-2" data-id="element-8">
            <span className="text-sm font-medium text-black" data-id="element-9">
              {t('about_caption')}
            </span>
          </div>
          <div className="absolute -bottom-8 -left-8 w-24 md:w-32 h-24 md:h-32 border border-neutral-200 -z-10 hidden md:block" data-id="element-10"></div>
        </div>

        {/* Right: text content */}
        <div className="order-1 md:order-2" data-id="element-11">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-6 md:mb-8 leading-tight" data-id="element-12">
            {t('about_h2')}
          </h2>
          <div className="space-y-4 md:space-y-6 text-base md:text-lg text-neutral-600 font-light leading-relaxed" data-id="element-13">
            <p data-id="element-14">{t('about_p1')}</p>
            <p data-id="element-15">{t('about_p2')}</p>
          </div>

          <div className="grid grid-cols-2 gap-6 md:gap-x-12 md:gap-y-12 mt-12 md:mt-16" data-id="element-16">
            <div className="flex flex-col border-l border-neutral-200 pl-4 md:pl-6 group hover:border-black transition-colors" data-id="element-17">
              <span className="text-3xl md:text-4xl font-bold text-black mb-2 group-hover:scale-105 transition-transform" data-id="element-18">
                10+
              </span>
              <span className="text-xs md:text-sm text-neutral-500 uppercase tracking-wider" data-id="element-19">
                {t('about_stat1_label')}
              </span>
            </div>
            <div className="flex flex-col border-l border-neutral-200 pl-4 md:pl-6 group hover:border-black transition-colors" data-id="element-20">
              <span className="text-3xl md:text-4xl font-bold text-black mb-2 group-hover:scale-105 transition-transform" data-id="element-21">
                300+
              </span>
              <span className="text-xs md:text-sm text-neutral-500 uppercase tracking-wider" data-id="element-22">
                {t('about_stat2_label')}
              </span>
            </div>
            <div className="flex flex-col border-l border-neutral-200 pl-4 md:pl-6 group hover:border-black transition-colors" data-id="element-23">
              <span className="text-3xl md:text-4xl font-bold text-black mb-2 group-hover:scale-105 transition-transform" data-id="element-24">
                1200+
              </span>
              <span className="text-xs md:text-sm text-neutral-500 uppercase tracking-wider" data-id="element-25">
                {t('about_stat3_label')}
              </span>
            </div>
            <div className="flex flex-col border-l border-neutral-200 pl-4 md:pl-6 group hover:border-black transition-colors" data-id="element-26">
              <span className="text-3xl md:text-4xl font-bold text-black mb-2 group-hover:scale-105 transition-transform" data-id="element-27">
                100%
              </span>
              <span className="text-xs md:text-sm text-neutral-500 uppercase tracking-wider" data-id="element-28">
                {t('about_stat4_label')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}